export default "__VITE_ASSET__5XFe2Ajb__"